import { useState } from 'react';

import { Switch } from '@/ui/switch/switch';
import { useToggleContentItemVisibility } from './use-toggle-content-item-visibility.mutation';

type Props = {
  contentItemId: string;
  isVisible: boolean;
};

export const ContentItemVisibilitySwitch = ({
  contentItemId,
  isVisible,
}: Props) => {
  const [isChecked, setIsChecked] = useState(isVisible);
  const { toggleContentItemVisibility } = useToggleContentItemVisibility();

  const toggle = async () => {
    setIsChecked(!isChecked);

    await toggleContentItemVisibility(contentItemId);
  };
  return (
    <Switch
      dataTestId="content-item-visibility-switch"
      checked={isChecked}
      onChange={toggle}
    />
  );
};
